import { stripLines } from "@services/typed_helpers";
import { Converter } from "showdown";

const htmlFromMarkdown = (markdown: string) => {
  const converter = new Converter();
  return converter.makeHtml(stripLines(markdown));
};

export { htmlFromMarkdown };
